import { render, staticRenderFns } from "./town-grid.vue?vue&type=template&id=314d2fd0"
import script from "./town-grid.vue?vue&type=script&lang=js"
export * from "./town-grid.vue?vue&type=script&lang=js"
import style0 from "./town-grid.vue?vue&type=style&index=0&id=314d2fd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports